


import avt1 from '../images/author/author2.png'
import avt2 from '../images/author/author3.png'
import avt3 from '../images/author/author13.png'
import avt4 from '../images/author/author4.png'
import avt5 from '../images/author/author5.png'
import avt6 from '../images/author/author6.png'
import avt7 from '../images/author/author7.png'
import avt8 from '../images/author/author8.png'
import avt9 from '../images/author/author9.png'
import avt10 from '../images/author/author10.png'
import avt11 from '../images/author/author11.png'
import avt12 from '../images/author/author12.png'
import avt13 from '../images/author/author25.png'
import avt14 from '../images/author/author26.png'
import avt15 from '../images/author/author27.png'
import avt16 from '../images/author/author28.png'
import avt17 from '../images/author/author29.png'
import avt18 from '../images/author/author30.png'



const dataSeller = [
    {
        id: 1,
        avt: avt1,
        price: '₹4300 Saved',
        name: 'Rameshverma',
    },
    {
        id: 2,
        avt: avt2,
        price: '₹4750 Saved',
        name: 'Khan Iqlak',
    },
    {
        id: 3,
        avt: avt3,
        price: '₹5680 Saved',
        name: 'Anirudh 1121',
    },
    {
        id: 4,
        avt: avt4,
        price: '₹8200 Saved',
        name: 'yales2121',
    },
    {
        id: 5,
        avt: avt5,
        price: '₹7700 Saved',
        name: 'lonewolf9218',
    },
    {
        id: 6,
        avt: avt6,
        price: '₹5400 Saved',
        name: 'Abhi1219',
    },
    {
        id: 7,
        avt: avt7,
        price: '₹2950 Saved',
        name: 'austonpal912',
    },
    {
        id: 8,
        avt: avt8,
        price: '₹13350 Saved',
        name: 'Das0912',
    },
    {
        id: 9,
        avt: avt9,
        price: '₹7600 Saved',
        name: 'mushtaq091',
    },
    {
        id: 10,
        avt: avt10,
        price: '₹11500 Saved',
        name: 'Gulwindersing48387',
    },
    {
        id: 11,
        avt: avt11,
        price: '₹13200 Saved',
        name: 'Taurus_gifts',
    },
    {
        id: 12,
        avt: avt12,
        price: '₹17500 Saved',
        name: 'topgiftcardvendor1',
    },


    {
        id: 13,
        avt: avt13,
        price: '₹10000 Saved',
        name: 'Wren Clark',
        numb: '1'
    },
    {
        id: 14,
        avt: avt14,
        price: '₹13400 Saved',
        name: 'Madge Dennis',
        numb: '2'
    },
    {
        id: 15,
        avt: avt15,
        price: '₹14000 Saved',
        name: 'Alfred Mitchell',
        numb: '3'
    },
    {
        id: 16,
        avt: avt16,
        price: '₹17000 Saved',
        name: 'Wren Clark',
        numb: '4'
    },
    {
        id: 17,
        avt: avt17,
        price: '₹16000 Saved',
        name: 'Troy Sharp',
        numb: '5'
    },
    {
        id: 18,
        avt: avt18,
        price: '₹15000 Saved',
        name: 'Len Davis',
        numb: '6'
    },

    

]

export default dataSeller;